<template>
  <div id="user-data">
    <vx-card :title="titleCard" class="mb-base">
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2">
          <div>
            <!-- <vs-input
              class="w-full mt-4"
              label="Código"
              v-model="casoId"
              v-validate="'required'"
              name="casoId"
              :disabled="true"
            />
            <span
              class="text-danger text-sm"
              v-show="
                errors.has('casoId') || formerr.includes('casoId')
              "
              >Por favor ingrese el c&oacute;digo</span
            > -->

            <vs-input class="w-full mt-1" label="Asunto" v-model="casoAsunto" v-validate="'required'"
              name="casoAsunto" />
            <span class="text-danger text-sm" v-show="
              errors.has('casoAsunto') || formerr.includes('casoAsunto')
            ">Por favor ingrese el asunto</span>

            <div class="w-full mt-4">
              <label for="casoDescripcion" class="vs-input--label">Descripción</label>
              <vs-textarea class="w-full mb-0" v-model="casoDescripcion" v-validate="'required'"
                name="casoDescripcion" />
              <span class="text-danger text-sm"
                v-show="errors.has('casoDescripcion') || formerr.includes('casoDescripcion')">Por favor ingrese la
                descripci&oacute;n</span>
            </div>

            <vs-input class="w-full mt-5" label="Área" v-model="casoArea" v-validate="'required'" name="casoArea"
              :disabled="true" />
            <span class="text-danger text-sm" v-show="
              errors.has('casoArea') || formerr.includes('casoArea')
            ">Por favor ingrese el área</span>
            <!--
            <vs-select v-model="casoProyectoId" name="casoProyectoId" label="Proyecto" class="w-full mt-4" :disabled="
              this.proyectoList === null ||
              this.proyectoList === undefined
            " @input="handleProyecto">
              <vs-select-item />
              <vs-select-item :key="item.id" :value="item.id" :text="item.descripcion" v-for="item in proyectoList" />
            </vs-select>
            <span class="text-danger text-sm"
              v-show="errors.has('casoProyectoId') || formerr.includes('casoProyectoId')">Por favor seleccione el
              proyecto</span>
-->
            <vs-select v-model="casoGesActivosId" name="casoGesActivosId" label="Activo" class="mt-4 w-full" :disabled="
              this.activosList === null ||
              this.activosList === undefined
            " @input="handleGesActivos" v-if="can('regreq_input_active')">
              <vs-select-item />
              <vs-select-item :key="item.id" :value="item.id" :text="item.nombre" v-for="item in activosList" />
            </vs-select>
            <span class="text-danger text-sm"
              v-show="errors.has('casoGesActivosId') || formerr.includes('casoGesActivosId')">Por favor seleccione el
              activo</span>

            <!-- <div class="w-full mt-4">
              <label for="fechaini" class="vs-input--label"
                >Fecha compromiso</label
              >
              <flat-pickr
                class="vs-inputx vs-input--input normal"
                id="fechaini"
                :config="configdateIni"
                v-model="fechaini"
                placeholder="aaaa-mm-dd H:m"
                @on-change="onToChange"
              />
              <span
                class="text-danger text-sm"
                v-show="
                  errors.has('fechaini') || formerr.includes('fechaini')
                "
                >Por favor ingrese la fecha compromiso</span>
            </div> -->
            <!--
            <vs-select v-model="casoServicioId" name="casoServicioId" label="Servicio" class="w-full mt-4" :disabled="
              this.servicesList === null ||
              this.servicesList === undefined
            " @input="handleServicio">
              <vs-select-item />
              <vs-select-item :key="item.id" :value="item.id" :text="item.descripcion" v-for="item in servicesList" />
            </vs-select>
            <span class="text-danger text-sm"
              v-show="errors.has('casoServicioId') || formerr.includes('casoServicioId')">Por favor seleccione el
              servicio</span>
-->
          </div>
        </div>

        <div class="vx-col w-full md:w-1/2">
          <div>
            <!-- <vs-input
              class="w-full mt-4"
              label="Código externo"
              v-model="casoCodigoExterno"
              v-validate="'required'"
              name="casoCodigoExterno"
              type="number"
              :disabled="!modeCreate"
            />
            <span
              class="text-danger text-sm"
              v-show="
                errors.has('casoCodigoExterno') || formerr.includes('casoCodigoExterno')
              "
              >Por favor ingrese el c&oacute;digo externo</span
            > -->
            <!--
            <vs-select v-model="casoGrupoTipoActividadId" name="casoGrupoTipoActividadId" label="Grupo tipo de caso"
              class="w-full mt-1" :disabled="
                this.grupo_tipo_actividadActive
              " @input="handleGrupoTipoCaso">
              <vs-select-item />
              <vs-select-item :key="item.id" :value="item.id" :text="item.descripcion"
                v-for="item in grupo_tipo_actividadList" />
            </vs-select>
            <span class="text-danger text-sm"
              v-show="errors.has('casoGrupoTipoActividadId') || formerr.includes('casoGrupoTipoActividadId')">Por favor
              seleccione el grupo tipo de caso</span>

            <vs-select v-model="casoTipoActividadId" name="casoTipoActividadId" label="Tipo de caso" class="mt-4 w-full"
              :disabled="
                this.tipoActividadList === null ||
                this.tipoActividadList == undefined
              ">
              <vs-select-item />
              <vs-select-item :key="item.id" :value="item.id" :text="item.descripcion"
                v-for="item in tipoActividadList" />
            </vs-select>
            <span class="text-danger text-sm"
              v-show="errors.has('casoTipoActividadId') || formerr.includes('casoTipoActividadId')">Por favor seleccione
              el tipo de caso</span>

            <vs-select v-model="casoAplicativo" name="casoAplicativo" label="Aplicaciones" class="w-full mt-4"
              :disabled="
                this.applicacionesList === null ||
                this.applicacionesList === undefined
              " @input="handleApplicative">
              <vs-select-item />
              <vs-select-item :key="item.id" :value="item.id" :text="item.descripcion"
                v-for="item in applicacionesList" />
            </vs-select>
            <span class="text-danger text-sm"
              v-show="errors.has('casoAplicativo') || formerr.includes('casoAplicativo')">Por favor seleccione la
              aplicación</span>

            <vs-select v-model="casoHelpDesk" name="casoHelpDesk" label="Infraestructura" class="mt-4 w-full" :disabled="
              this.infraestructuraList === null ||
              this.infraestructuraList === undefined
            " @input="handleHelpDesk">
              <vs-select-item />
              <vs-select-item :key="item.id" :value="item.id" :text="item.descripcion"
                v-for="item in infraestructuraList" />
            </vs-select>
            <span class="text-danger text-sm"
              v-show="errors.has('casoHelpDesk') || formerr.includes('casoHelpDesk')">Por favor seleccione la
              infraestructura</span>
-->
            <div class="w-full mt-4">
              <label for="files" class="vs-input--label">Adjuntar archivos</label>
              <file-pond name="test" ref="pond" label-idle="Suelta los archivos aquí..." class="w-full"
                allow-multiple="true" accepted-file-types="image/jpeg, image/png" v-on:addfile="handleFilePondAddFile"
                v-on:removefile="handleFilePondRemoveFile" v-on:init="handleFilePondInit" />
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <div class="vx-col w-full flex" id="account-manage-buttons">
      <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" @click="actionSaveData">Guardar</vs-button>
      <vs-button type="border" color="danger" icon-pack="feather" @click="closeSidebar">Cancelar</vs-button>
    </div>
  </div>
</template>

<script>

// Import Vue FilePond
import vueFilePond from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'

// Create component
const FilePond = vueFilePond()
//////////////////////////////////////////////////////////////////////////////////////////////////////////////
import ListasModule from '@/store/listas-module/moduleDataList.js'
import Datepicker from 'vuejs-datepicker'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish as SpanishLocale } from 'flatpickr/dist/l10n/es.js'
import { searchCompany } from '../../../config/companies.js'
import can from '../../../helpers/can'

export default {
  components: {
    Datepicker,
    flatPickr,
    FilePond
  },
  props: {
    casoDataProp: {
      type: Object,
      default: () => { }
    },
    createNewCasoProp: {
      type: Function
    },
    editCasoProp: {
      type: Function
    },
    closeSidebarProp: {
      type: Function
    }
  },
  data() {
    return {
      titleCard: '', // Crear/Modificar Caso
      modeCreate: true, // Crear => true/Modificar => false
      formerr: [], // Crear => true/Modificar => false
      company: null,
      casoId: null,
      casoAsunto: '',
      casoDescripcion: '',
      casoArea: this.$store.state.auth.userDetails().department || '',
      casoServicioId: null,
      casoProyectoId: '',
      casoGrupoTipoActividadId: null,
      casoTipoActividadId: null,
      casoCodigoExterno: null,
      casoTipoActividadExternaId: null,
      casoPrioridadId: null,
      casoCriticalityId: null,
      casoItilIncidentType: null,
      casoAplicativo: null,
      casoHelpDesk: null,
      casoGesActivosId: null,
      casoGesActivos: null,
      prioridadList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      myFiles: [],
      user_data: {},
      user_not_found: false,
      dob: new Date(),
      fechaini: null,
      configdateIni: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i ',
        locale: SpanishLocale,
        maxDate: null
        // enableSeconds: true,
      },
      can
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.formerr.length <= 0
    },

    activosList() {
      return this.$store.state.ListasModule.ges_activos
    },
    proyectoList() {
      return this.$store.state.ListasModule.proyecto
    },
    servicesList() {
      return this.$store.state.ListasModule.servicios
    },
    grupo_tipo_actividadActive() {
      return this.$store.state.ListasModule.grupo_tipo_actividad.length === 0
    },
    grupo_tipo_actividadList() {
      return this.$store.state.ListasModule.grupo_tipo_actividad
    },
    tipoActividadList() {
      return this.$store.state.ListasModule.tipo_actividad
    },
    applicacionesList() {
      return this.$store.state.ListasModule.applicative
    },
    infraestructuraList() {
      return this.$store.state.ListasModule.help_desk
    }
  },
  created() {
    this.company = searchCompany(this.$route.params.nameCompany)

    this.initParams()
    this.initListOfValues()
  },
  watch: {
    casoDataProp() {
      this.initParams()
    }
  },
  methods: {
    initListOfValues() {
      if (!ListasModule.isRegistered) {
        this.$store.registerModule('ListasModule', ListasModule)
        ListasModule.isRegistered = true
      }

      this.$vs.loading()
      this.$store
        .dispatch('ListasModule/getAllProyecto', { ...this.company, idUser: this.$store.state.auth.userDetails().id })
        .then((response) => {
          this.$vs.loading.close()

          if (response.data) {
            const list = response.data.listaProyecto
            if (list) {
              if (list.length === 1) {
                const id = list[0].id
                this.casoProyectoId = id

                this.handleProyecto(id)
              }
            }
          }
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    initParams(force = false) {
      if (
        force ||
        (this.casoDataProp !== null) ||
        this.casoDataProp.id === null ||
        this.casoDataProp.id === undefined ||
        this.casoDataProp.id === ''
      ) {
        this.modeCreate = true
        this.titleCard = 'Crear caso'
        this.casoId = null
        this.casoAsunto = ''
        this.casoDescripcion = ''
        this.casoServicioId = null
        this.casoTipoActividadId = null
        this.fechaini = null
        this.casoCodigoExterno = null
        this.casoTipoActividadExternaId = null
        this.casoPrioridadId = null
        this.casoCriticalityId = null
        this.casoItilIncidentType = null
        this.casoGesActivosId = null
        this.casoGesActivos = null
      } else {
        console.log(
          'Modificando, this.casoDataProp',
          this.casoDataProp
        )
        this.modeCreate = false
        this.titleCard = 'Modificar caso'
        this.casoId = this.casoDataProp.id
        this.casoAsunto = this.casoDataProp.asunto
        this.casoDescripcion = this.casoDataProp.descripcion
        this.casoServicioId = this.casoDataProp.requestTypeService ? this.casoDataProp.requestTypeService.id : 0
        this.casoTipoActividadId = this.casoDataProp.tipoActividad ? this.casoDataProp.tipoActividad.id : 0
        this.fechaini = this.casoDataProp.fechaAcordada
        this.casoCodigoExterno = this.casoDataProp.USU_RESPO_NOMBRE
        this.casoTipoActividadExternaId = this.casoDataProp.tipoActividadExterna ? this.casoDataProp.tipoActividadExterna.id : 0
        this.casoPrioridadId = this.casoDataProp.prioridad
        this.casoCriticalityId = this.casoDataProp.criticality ? this.casoDataProp.criticality.id : 0
        this.casoItilIncidentType = this.casoDataProp.itilIncidentType ? this.casoDataProp.itilIncidentType.id : 0
        this.casoGesActivosId = this.casoDataProp.gesActivoId
        this.casoGesActivos = this.casoDataProp.gesActivo
      }

      this.$validator.reset()
    },
    actionSaveData() {
      //console.log('this.myFiles', this.myFiles)
      //console.log('user', this.$store.state.auth.userDetails())
      //console.log('nameCompany', this.$route.params.nameCompany)

      if (!this.company) {
        alert('El nombre de la compañia no es correcto.')

        return
      }

      /*this.myFiles.forEach(element => {
        console.log('file', element.name)
      })*/

      this.formerr = []
      if (
        this.casoId === null ||
        this.casoId === undefined
      ) {
        //TODO, revisar la validación
        //this.formerr.push('casoId')
      }
      if (
        this.casoAsunto === null ||
        this.casoAsunto === undefined ||
        this.casoAsunto.trim() === ''
      ) {
        this.formerr.push('casoAsunto')
      }
      if (
        this.casoDescripcion === null ||
        this.casoDescripcion === undefined ||
        this.casoDescripcion.trim() === ''
      ) {
        this.formerr.push('casoDescripcion')
      }
      /**
            if (
              this.casoServicioId === null ||
              this.casoServicioId === undefined ||
              this.casoServicioId === ''
            ) {
              this.formerr.push('casoServicioId')
            }

            if (
              this.casoProyectoId === null ||
              this.casoProyectoId === undefined ||
              this.casoProyectoId === ''
            ) {
              this.formerr.push('casoProyectoId')
            }
            if (!this.grupo_tipo_actividadActive) {
              if (
                this.casoGrupoTipoActividadId === null ||
                this.casoGrupoTipoActividadId === undefined
              ) {
                this.formerr.push('casoGrupoTipoActividadId')
              }
            }
            if (
              this.casoTipoActividadId === null ||
              this.casoTipoActividadId === undefined ||
              this.casoTipoActividadId === ''
            ) {
              this.formerr.push('casoTipoActividadId')
            }
            // if (
            //   this.fechaini === null ||
            //   this.fechaini === undefined ||
            //   this.fechaini === ''
            // ) {
            //   this.formerr.push('fechaini')
            // }
            // if (
            //   this.casoCodigoExterno === null ||
            //   this.casoCodigoExterno === undefined ||
            //   this.casoCodigoExterno === ''
            // ) {
            //   this.formerr.push('casoCodigoExterno')
            // }
            // if (
            //   this.casoTipoActividadExternaId === null ||
            //   this.casoTipoActividadExternaId === undefined
            // ) {
            //   this.formerr.push('casoTipoActividadExternaId')
            // }
            // if (
            //   this.casoPrioridadId === null ||
            //   this.casoPrioridadId === undefined ||
            //   this.casoPrioridadId === ''
            // ) {
            //   this.formerr.push('casoPrioridadId')
            // }
            if (this.casoHelpDesk === null) {
              if (
                this.casoAplicativo === null ||
                this.casoAplicativo === undefined ||
                this.casoAplicativo === ''
              ) {
                this.formerr.push('casoAplicativo')
              }
            }

            if (this.casoAplicativo === null) {
              if (
                this.casoHelpDesk === null ||
                this.casoHelpDesk === undefined ||
                this.casoHelpDesk === ''
              ) {
                this.formerr.push('casoHelpDesk')
              }
            }
      **/
      // if (
      //   this.casoCriticalityId === null ||
      //   this.casoCriticalityId === undefined ||
      //   this.casoCriticalityId === ''
      // ) {
      //   this.formerr.push('casoCriticalityId')
      // }
      // if (
      //   this.casoItilIncidentType === null ||
      //   this.casoItilIncidentType === undefined ||
      //   this.casoItilIncidentType === ''
      // ) {
      //   this.formerr.push('casoItilIncidentType')
      // }
      if (can('regreq_input_active')) {
        if (
          this.casoGesActivosId === null ||
          this.casoGesActivosId === undefined ||
          this.casoGesActivosId === ''
        ) {
          this.formerr.push('casoGesActivosId')
        }
      }

      if (this.validateForm) {

        //console.log('this.casoAplicativo', this.casoAplicativo)
        //console.log('this.casoHelpDesk', this.casoHelpDesk)

        const casoDataProp = {
          id: -1, //this.casoId,
          company: { id: this.company.idCompany, descripcion: '' },
          tipoActividadExterna: { id: 104/*this.casoTipoActividadExternaId*/, idCompania: this.company.idCompany, descripcion: '' },
          codigoInterno: -1/*this.casoCodigoExterno*/,
          descripcion: this.casoDescripcion,
          prioridad: 5, //this.casoPrioridadId,
          //groupTipCaso: this.grupo_tipo_actividadActive ? null : { id: this.casoGrupoTipoActividadId, descripcion: '' },
          groupTipCaso: { id: -1, descripcion: '' },
          //tipoActividad: { id: /*12*/this.casoTipoActividadId, idCompania: this.company.idCompany, descripcion: '' },
          tipoActividad: { id: -1, idCompania: this.company.idCompany, descripcion: '' },
          usuario: this.$store.state.auth.userDetails().id, // 279,
          proyecto: { id: /*this.company.idProject, this.casoProyectoId*/ this.company.idProject, idCompania: this.company.idCompany, descripcion: '' },
          subproyecto: { id: null, idCompania: null, descripcion: '' },
          usuarioAsignado: { id: this.$store.state.auth.userDetails().id, name: this.$store.state.auth.userDetails().name },
          fechaAcordada: null/*this.fechaini*/,
          criticality: { id: 4/*this.casoCriticalityId*/, descripcion: '' },
          itilIncidentType: { id: 1/*this.casoItilIncidentType*/, descripcion: '' },
          requestTypeService: { id: /*-1, this.casoServicioId */ this.company.idRequestTypeService, descripcion: '' },
          app: { id: /*this.casoAplicativo*/ -1, descripcion: '' },
          helpDeskService: { id: /*this.casoHelpDesk*/ -1, descripcion: '' },
          subject_req: this.casoAsunto,
          area: { id: -1, descripcion: this.casoArea },
          source: { id: 1, descripcion: '' },
          gesActivo: can('regreq_input_active') ? { ...this.casoGesActivos, idusuario: this.$store.state.auth.userDetails().id } : null,
          //gesActivoId: this.casoGesActivosId,
          myFiles: this.myFiles
        }

        if (this.modeCreate) {
          this.createNewCasoProp(casoDataProp)
        } else {
          this.editCasoProp(casoDataProp)
        }
      } else {
        console.log('Hay errores que resolver', this.errors)
      }
    },
    handleProyecto(item) {
      //console.log('handleProyecto item, ', item)

      this.casoGesActivosId = null
      this.casoServicioId = null
      this.casoGrupoTipoActividadId = null
      this.casoTipoActividadId = null
      this.casoAplicativo = null
      this.casoHelpDesk = null

      this.$store.dispatch('ListasModule/clearAllGesActivosByUser')
      this.$store.dispatch('ListasModule/clearAllServicios')
      this.$store.dispatch('ListasModule/clearAllApplicative')
      this.$store.dispatch('ListasModule/clearAllHelpDesk')
      this.$store.dispatch('ListasModule/clearAllGrupoTipoActividad')
      this.$store.dispatch('ListasModule/clearAllTipoActividad')

      if (item) {
        const companyTemp = this.company
        companyTemp.idProject = item
        //companyTemp.idGrupoRequestType = -1
        console.log('companyTemp', companyTemp)

        if (can('regreq_input_active')) {
          this.$vs.loading()
          this.$store
            .dispatch('ListasModule/getGesActivosByUser', { ...companyTemp, idUser: this.$store.state.auth.userDetails().id })
            .then(() => {
              this.$vs.loading.close()
            })
            .catch(() => {
              this.$vs.loading.close()
            })
        }

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllServicios', companyTemp)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllApplicative', companyTemp)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllHelpDesk', companyTemp)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllGrupoTipoActividad', { ...companyTemp, idUser: this.$store.state.auth.userDetails().id })
          .then((response) => {
            this.$vs.loading.close()

            if (response.data) {
              if (response.data.listaGroupTipCaso.length === 0) {
                this.handleGrupoTipoCaso(-1)
              }
            }
          })
          .catch(() => {
            this.$vs.loading.close()
          })

        /*this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllTipoActividad', companyTemp)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })*/

      }
    },
    handleServicio(item) {
      //console.log('handleServicio item, ', item)

      this.casoTipoActividadId = null
      this.$store
        .dispatch('ListasModule/setAllTipoActividad', { lista: [] })

      if (item !== null) {
        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllTipoActividad',
            {
              ...this.company,
              idGrupoRequestType: this.casoGrupoTipoActividadId || -1,
              idRequestTypeService: item
            })
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      }
    },
    handleGrupoTipoCaso(item) {
      //console.log('handleGrupoTipoCaso item, ', item)

      this.casoTipoActividadId = null
      this.$store
        .dispatch('ListasModule/setAllTipoActividad', { lista: [] })

      if (item !== null) {
        this.$vs.loading()
        this.$store
          .dispatch('ListasModule/getAllTipoActividad',
            {
              ...this.company,
              idGrupoRequestType: item,
              idRequestTypeService: this.casoServicioId || -1
            })
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      }
    },
    handleApplicative() {
      this.casoHelpDesk = null
    },
    handleHelpDesk() {
      this.casoAplicativo = null
    },
    handleGesActivos(item) {
      this.casoGesActivosId = item
      //console.log('Selected, ', item)

      const selected = this.activosList.find(gesActivo => {
        return item === gesActivo.id
      })

      this.casoGesActivos = selected
      //console.log('Selected object, ', this.casoGesActivos)
    },
    handleFilePondInit() {
      console.log('FilePond has initialized')

      // FilePond instance methods are available on `this.$refs.pond`
    },
    handleFilePondAddFile(error, file) {
      if (error) {
        return
      }
      //console.log('file', file)

      this.myFiles.push(file.file)

    },
    handleFilePondRemoveFile(error, file) {
      if (error) {
        return
      }
      //console.log('file', file)

      this.myFiles.map((item, index) => {
        if (item.name === file.filename) {
          this.myFiles.splice(index, 1)
        }
      })
    },
    closeSidebar() {
      this.closeSidebarProp()
    },
    onToChange(selectedDates, dateStr, instance) {
      this.$set(this.configdateIni, 'maxDate', dateStr)
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    }
  }
}
</script>
